"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var functionList_1 = require("./functionList");
var requestTypes_1 = require("../../../../src-client-lib/api/requestTypes");
var RealTimeDataService = /** @class */ (function () {
    function RealTimeDataService() {
        var _this = this;
        this.realtimeDataSources = [];
        this.realtimeDataCallback = function (data) {
            if (data.typeId === requestTypes_1.RequestType.SubscribeRealTimeDataResponse)
                return;
            if (data.epochSecond == null) {
                data.epochSecond = Math.round(data.timestamp / 1000);
            }
            // source data is immutable
            Object.freeze(data);
            var dataSource = _this.getRealtimeDataSource(data.dataset);
            if (dataSource) {
                dataSource.latestValue = data;
                _this.emitRealtimeData(data);
            }
        };
    }
    /**
     * Emits new data to the source BehaviorSubject.
     * @param data Tick data from the server
     */
    RealTimeDataService.prototype.emitRealtimeData = function (data) {
        var datasetId = data.dataset;
        var realtimeDataSource = this.realtimeDataSources.find(function (s) { return s.datasetId === datasetId; });
        if (realtimeDataSource) {
            realtimeDataSource.source.next(data);
        }
        else {
            throw Error("Realtime data received for " + datasetId + " but cound not find any RealtimeDataSource.");
        }
    };
    RealTimeDataService.prototype.subscribeRealtimeDataFromLegneds = function (legends, resolution) {
        var _this = this;
        if (resolution === void 0) { resolution = 0; }
        var subscriptions = [];
        legends.forEach(function (l) {
            Object.keys(l.mappings).forEach(function (key) {
                var datasetId = l.mappings[key].datasetId;
                var subscripiton = _this.subscribeRealtimeData(datasetId, resolution);
                subscriptions.push(subscripiton);
            });
        });
        var subscriptionsFromFuntions = this.subscribeRealtimeDataFromFunctions(legends, resolution);
        return subscriptions.concat(subscriptionsFromFuntions);
    };
    RealTimeDataService.prototype.subscribeRealtimeDataFromFunctions = function (legends, resolution) {
        var _this = this;
        if (resolution === void 0) { resolution = 0; }
        var subscriptions = [];
        legends.forEach(function (l) {
            if (l.serverSideFunction) {
                l.serverSideFunction.forEach(function (fn) {
                    // Request realtime data if TSCalculate has no endtime
                    if (fn.name === functionList_1.Functions.TSCalculate && (fn.params[3] == null || fn.params[9])) {
                        var subscripiton = _this.subscribeRealtimeData(fn.params[0], resolution);
                        subscriptions.push(subscripiton);
                    }
                });
            }
        });
        return subscriptions;
    };
    RealTimeDataService.prototype.subscribeRealtimeData = function (datasetId, resolution) {
        var subscription;
        var realtimeDataSource = this.getRealtimeDataSource(datasetId);
        if (realtimeDataSource) {
            subscription = this.createSubscription(realtimeDataSource, resolution);
            realtimeDataSource.subscriptions.push(subscription);
        }
        else {
            var newSource = this.createRealtimeDataSource(datasetId);
            subscription = this.createSubscription(newSource, resolution);
            newSource.subscriptions.push(subscription);
            this.realtimeDataSources.push(newSource);
        }
        return subscription;
    };
    RealTimeDataService.prototype.unsubscribeAll = function (subscriptions) {
        var _this = this;
        subscriptions.forEach(function (s) { return _this.unsubscribeRealtimeData(s); });
    };
    RealTimeDataService.prototype.unsubscribeRealtimeData = function (subscription) {
        var realtimeDataSource = this.getRealtimeDataSourceBySubscriptionId(subscription.id);
        if (realtimeDataSource) {
            realtimeDataSource.subscriptions = realtimeDataSource.subscriptions.filter(function (s) { return s.id !== subscription.id; });
            if (realtimeDataSource.subscriptions.length === 0) {
                smashClient.deregisterRealtimeDataCallback(realtimeDataSource.callbackId);
                realtimeDataSource.source.complete();
                this.realtimeDataSources = this.realtimeDataSources.filter(function (s) { return s.datasetId !== realtimeDataSource.datasetId; });
            }
        }
    };
    RealTimeDataService.prototype.getLatestData = function (datasetId) {
        var realtimeDataSource = this.getRealtimeDataSource(datasetId);
        return realtimeDataSource ? realtimeDataSource.latestValue : null;
    };
    /**
     * Creates RealtimeDataSource.
     * This will send realtime data subscription to the server.
     * @param datasetId
     */
    RealTimeDataService.prototype.createRealtimeDataSource = function (datasetId) {
        var callbackId = smashClient.registerRealtimeDataCallback(datasetId, this.realtimeDataCallback);
        var source = new rxjs_1.BehaviorSubject(null);
        return {
            datasetId: datasetId,
            source: source,
            latestValue: null,
            subscriptions: [],
            callbackId: callbackId
        };
    };
    /**
     * Creates a subscription.
     * @param realTimeDataSource
     * @param resolution          resolution in milliseconds.
     */
    RealTimeDataService.prototype.createSubscription = function (realTimeDataSource, resolution) {
        return {
            id: new Date().getTime().toString(),
            resolution: resolution,
            dataStream: this.createObservable(realTimeDataSource.source, resolution)
        };
    };
    /**
     * Creates an observable with throttle time.
     * @param source      source BehaviorSubject which new data will be emitted to.
     * @param resolution  resolution in milliseconds.
     */
    RealTimeDataService.prototype.createObservable = function (source, resolution) {
        if (resolution === void 0) { resolution = 0; }
        var observable = source.asObservable();
        return resolution === 0 ? observable : rxjs_1.Observable.interval(resolution).map(function (_) { return source.getValue(); });
    };
    RealTimeDataService.prototype.getRealtimeDataSource = function (datasetId) {
        return this.realtimeDataSources.find(function (s) { return s.datasetId === datasetId; });
    };
    RealTimeDataService.prototype.getRealtimeDataSourceBySubscriptionId = function (subscriptionId) {
        var source = null;
        this.realtimeDataSources.forEach(function (rs) {
            var subscription = rs.subscriptions.find(function (s) { return s.id === subscriptionId; });
            if (subscription) {
                source = rs;
            }
        });
        return source;
    };
    return RealTimeDataService;
}());
var instance = new RealTimeDataService();
exports.default = instance;
//# sourceMappingURL=realtimeDataService.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/realtimeDataService.js